const bookingTypes = {
  INQUIRY: 'INQUIRY',
  INSTANT: 'INSTANT',
};

export default bookingTypes;
